/* eslint-disable */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
// chakra imports
import { Box, Flex, HStack, Text, useColorModeValue, Collapse } from "@chakra-ui/react";

export function SidebarLinks(props) {
  //   Chakra color mode
  let location = useLocation();
  let activeColor = useColorModeValue("gray.700", "white");
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "gray.400"
  );
  let activeIcon = useColorModeValue("brand.500", "white");
  let textColor = useColorModeValue("secondaryGray.500", "gray.300");
  let brandColor = useColorModeValue("brand.500", "brand.500");
  let categoryTextColor = useColorModeValue("secondaryGray.400", "gray.500");

  const { routes } = props;

  // Enhanced active route logic for categories and subitems
  const isRouteActive = (routePath) => {
    // Exact match
    if (location.pathname === routePath) {
      return true;
    }
    
    // For conversations route, also match child routes like /conversations/:id
    if (routePath === '/admin/conversations' && location.pathname.startsWith('/admin/conversations/')) {
      return true;
    }
    
    return false;
  };

  const isCategoryActive = (categoryItems) => {
    return categoryItems.some(item => isRouteActive(item.layout + item.path));
  };

  const getActiveItemInCategory = (categoryItems) => {
    return categoryItems.find(item => isRouteActive(item.layout + item.path));
  };

  // Redesigned createLinks function for cohesive UI
  const createLinks = (routes) => {
    return routes.filter(route => !route.hideFromSidebar).map((route, index) => {
      if (route.category) {
        const categoryActive = isCategoryActive(route.items);
        const activeItem = getActiveItemInCategory(route.items);
        
        // Always show all items in the category
        const itemsToShow = route.items.filter(item => !item.hideFromSidebar);
        
        return (
          <Box key={index} mb='20px'>
            {/* Category Header - with different shade when active */}
            <Text
              fontSize="xs"
              color={categoryActive ? brandColor : categoryTextColor}
              fontWeight='bold'
              letterSpacing='1px'
              textTransform='uppercase'
              mx='auto'
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              pt='18px'
              pb='8px'
              transition='all 0.2s ease'>
              {route.name}
            </Text>
            
            {/* Category Items */}
            <Box>
              {itemsToShow.map((item, itemIndex) => {
                const isActive = isRouteActive(item.layout + item.path);
                
                return (
                  <NavLink key={itemIndex} to={item.layout + item.path}>
                    <Box
                      position='relative'
                      mb='2px'>
                      <HStack
                        spacing='22px'
                        py='8px'
                        px='16px'
                        borderRadius='12px'
                        mx='8px'
                        bg={isActive ? 'brand.500' : 'transparent'}
                        _hover={{
                          bg: isActive ? 'brand.500' : 'whiteAlpha.100'
                        }}
                        transition='all 0.2s ease'
                        align='flex-start'>
                        
                        {item.icon && (
                          <Box
                            color={isActive ? 'white' : textColor}
                            mt={item.email ? '2px' : '0px'}
                            transition='all 0.2s ease'>
                            {item.icon}
                          </Box>
                        )}
                        
                        <Flex direction='column' flex='1'>
                          <Text
                            color={isActive ? 'white' : textColor}
                            fontWeight={isActive ? 'semibold' : 'normal'}
                            fontSize='sm'
                            transition='all 0.2s ease'>
                            {item.name}
                          </Text>
                          {item.email && (
                            <Text
                              fontSize='xs'
                              color={isActive ? 'whiteAlpha.700' : inactiveColor}
                              mt='2px'
                              transition='all 0.2s ease'>
                              {item.email}
                            </Text>
                          )}
                        </Flex>
                      </HStack>
                    </Box>
                  </NavLink>
                );
              })}
            </Box>
          </Box>
        );
      } else if (
        route.layout === "/admin" ||
        route.layout === "/auth" ||
        route.layout === "/rtl"
      ) {
        const isActive = isRouteActive(route.layout + route.path);
        
        return (
          <NavLink key={index} to={route.layout + route.path}>
            <Box
              position='relative'
              mb='4px'>
              <HStack
                spacing='22px'
                py='12px'
                px='16px'
                borderRadius='12px'
                mx='0px'
                bg={isActive ? 'brand.500' : 'transparent'}
                _hover={{
                  bg: isActive ? 'brand.500' : 'whiteAlpha.100'
                }}
                transition='all 0.2s ease'>
                
                <Flex w='100%' alignItems='center'>
                  {route.icon && (
                    <Box
                      color={isActive ? 'white' : textColor}
                      me='18px'
                      transition='all 0.2s ease'>
                      {route.icon}
                    </Box>
                  )}
                  
                  <Text
                    me='auto'
                    color={isActive ? 'white' : textColor}
                    fontWeight={isActive ? 'semibold' : 'normal'}
                    fontSize='md'
                    transition='all 0.2s ease'>
                    {route.name}
                  </Text>
                </Flex>
              </HStack>
            </Box>
          </NavLink>
        );
      }
    });
  };
  //  BRAND
  return createLinks(routes);
}

export default SidebarLinks;
